<template>
  <div class="form-check" :class="[inline ? 'form-check-inline' : '', switchClass, buttonClass]">
    <input
      :id="inputId"
      ref="input"
      :type="type"
      :class="inputClasses"
      :name="name"
      :value="value"
      :checked="isChecked"
      :disabled="disabled"
      :indeterminate="indeterminate"
      :required="required"
      :aria-label="ariaLabel"
      data-testid="bs-form-checkbox"
      @change="handleChange"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    />
    <label
      v-if="$slots.default || label"
      :for="inputId"
      class="form-check-label"
      :class="{ 'text-muted': disabled }"
    >
      <slot>{{ label }}</slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'BsFormCheckbox',
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    checked: {
      type: [Boolean, Array, String, Number],
      default: false,
    },
    value: {
      type: [String, Number, Boolean],
      default: true,
    },
    name: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    switch: {
      type: Boolean,
      default: false,
    },
    button: {
      type: Boolean,
      default: false,
    },
    buttonVariant: {
      type: String,
      default: 'secondary',
    },
    plain: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    uncheckedValue: {
      type: [String, Number, Boolean],
      default: false,
    },
  },
  computed: {
    inputId() {
      return this.id || `bs-checkbox-${this._uid}`;
    },
    type() {
      return 'checkbox';
    },
    inputClasses() {
      const classes = [];
      if (!this.plain) {
        classes.push('form-check-input');
      }
      if (this.isChecked) {
        classes.push('active');
      }
      return classes;
    },
    switchClass() {
      if (this.switch && !this.button) {
        return 'form-switch';
      }
      return '';
    },
    buttonClass() {
      if (this.button) {
        return 'btn-check';
      }
      return '';
    },
    isChecked() {
      if (Array.isArray(this.checked)) {
        return this.checked.includes(this.value);
      }
      return this.checked === true || this.checked === this.value;
    },
  },
  methods: {
    handleChange(event) {
      if (this.disabled) return;

      let newChecked;
      if (Array.isArray(this.checked)) {
        const idx = this.checked.indexOf(this.value);
        if (event.target.checked) {
          newChecked = [...this.checked, this.value];
        } else {
          newChecked = this.checked.filter((v) => v !== this.value);
        }
      } else {
        newChecked = event.target.checked ? this.value : this.uncheckedValue;
      }

      this.$emit('change', newChecked);
      this.$emit('input', newChecked);
    },
    focus() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    },
  },
};
</script>
